const trevTheme = {
  colors: {
    docBackground: "#ffffff",
    coloredBackground: "#f3f3f3",
    textColor: "#000000",
    buttonBackground: "#0d90af",
    buttonTextColor: "#ffffff",
    brandColor: "#0d90af",
    headerBg: "#0d90af",
    borderColor: "#EBEBEB",
    defaultBannerBg: "#015E75",
  },
  breakpoints: {
    ns: "screen and (min-width: 30em)",
    medium: "screen and (min-width: 30em)",
    large: "screen and (min-width: 64em)",
    xl: "screen and (min-width: 94em)",
  },
  fontSizes: {
    h1: "calc(30px + (42 - 30) * ((100vw - 320px) / (1800 - 320)))",
    h2: "calc(22px + (32 - 22) * ((100vw - 320px) / (1800 - 320)))",
    h3: "calc(19px + (21 - 19) * ((100vw - 320px) / (1800 - 320)))",
    h4: "18px",
    h5: "14px",
    bodyReg: "16px",
  },
  lineHeight: {
    standard: "1.4",
    body: "1.9",
  },
  measures: {
    large: "50em",
    standard: "30em",
    narrow: "20em",
  },
  maxWidths: {
    narrow: "32rem",
    standard: "64rem",
    wide: "94rem",
  },
  padding: {
    headerMobile: "1.5rem",
    hMobile: "2rem",
    hDesk: "3vw",
    vMobile: "2rem",
  },
  wrappers: {
    standard: "3vw",
    large: "12vw",
  },
  containerWidths: {
    narrow: "1000px",
    standard: "1280px",
    medium: "1320px",
  },
  pageSpacers: {
    small: "20px",
    medium: "60px",
    large: "200px",
  },
  spacers: {
    small: ".50rem",
    standard: "2rem",
    med: "4rem",
    large: "8rem",
    xl: "16rem",
  },
}

export default trevTheme
